import { useLocation, useNavigate } from 'react-router-dom';
import { useEffect, useMemo } from 'react';
import i18n from 'i18next';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import WhatIsSection from './components/WhatIsSection';
import CategoriesSection from './components/CategoriesSection';
import ProductShowcase from './components/ProductShowcase';
import FeaturedSection from './components/FeaturedSection';
import GuidesSection from './components/GuidesSection';
import WhySection from './components/WhySection';
import CompareSection from './components/CompareSection';
import SafetySection from './components/SafetySection';
import FaqSection from './components/FaqSection';
import FinalCtaSection from './components/FinalCtaSection';

export default function HomePage() {
  const location = useLocation();
  const navigate = useNavigate();

  const lang = useMemo(() => {
    const pathLang = location.pathname.split('/')[1];
    if (['en', 'fr', 'de', 'da'].includes(pathLang)) return pathLang;
    return 'en';
  }, [location.pathname]);

  useEffect(() => {
    if (i18n.language !== lang) {
      i18n.changeLanguage(lang);
    }
  }, [lang]);

  // Handle hash-based scrolling on page load / route change
  useEffect(() => {
    if (location.hash) {
      const id = location.hash.slice(1);
      const el = document.getElementById(id);
      if (el) {
        const timer = setTimeout(() => {
          el.scrollIntoView({ behavior: 'smooth' });
        }, 150);
        return () => clearTimeout(timer);
      }
    }
  }, [location.hash, location.pathname]);

  // Clear hash after navigation to avoid scroll re-triggering
  useEffect(() => {
    if (location.hash && !location.pathname.includes('/article/')) {
      const timer = setTimeout(() => {
        navigate(location.pathname, { replace: true });
      }, 800);
      return () => clearTimeout(timer);
    }
  }, [location.hash, location.pathname, navigate]);

  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <Navbar lang={lang} />
      <main className="flex-1">
        <HeroSection />
        <WhatIsSection />
        <CategoriesSection />
        <ProductShowcase />
        <FeaturedSection />
        <GuidesSection lang={lang} />
        <WhySection />
        <CompareSection />
        <SafetySection />
        <FaqSection />
        <FinalCtaSection />
      </main>
      <Footer lang={lang} />
    </div>
  );
}